<template>
  <main class="layout">
    <div class="layout__content">
      <RouterView />
    </div>
  </main>
  <footer></footer>
  <ui-snackbar v-model="isActive">{{ text }}</ui-snackbar>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useSnackbar } from '@/composables/snackbar'

const { isActive, text } = useSnackbar()
</script>

<style lang="sass">
@use '@/styles/variables'
@use '@/styles/mixins'
@use 'sass:map'

.layout
  padding: variables.$spacer*10 variables.$spacer*2 0 variables.$spacer*2

  +mixins.media-breakpoint-mobile
    padding-top: variables.$spacer*5

  &__content
    width: 100%
    margin: auto
    max-width: variables.$content-max-width

footer
  background-color: map.get(variables.$background-color, card)

  &:not(:empty)
    margin-top: variables.$spacer*5
</style>
